import logoNauti from '../assets/images/icon_logo.png';

import React, {useContext, useRef, useState} from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslateContext } from "./translate.context";
import { Image } from 'react-bootstrap';
import { treatError } from '../utilities/auxiliary-functions';
import { Button } from '@mui/material'


type UseModalShowReturnType = {
    show: boolean;
    setShow: (value: boolean) => void;
    onHide: () => void;
}

const useModalShow = (): UseModalShowReturnType => {
    const [ show, setShow ] = useState(false);

    const handleOnHide = () => {
        setShow(false);
    };

    return {
        show,
        setShow,
        onHide: handleOnHide,
    }
};

type ModalContextType = {
    show: (type: number, title: string, message: string | JSX.Element) => Promise<boolean>;
};

type AlertMessageContextProviderProps = {
    children: React.ReactNode
}

const AlertMessageContext = React.createContext<ModalContextType>({} as ModalContextType);

const AlertMessageContextProvider: React.FC<AlertMessageContextProviderProps> = (props) => {

    const { display } = useTranslateContext();

    const { setShow, show, onHide } = useModalShow();
    const [ content, setContent ] = useState<{ type: number, title: string, message: string | JSX.Element} | null>();
    const resolver = useRef<Function>();

    const onShow = (type: number, title: string, message: string | JSX.Element): Promise<boolean> => {
        setContent({
            type,
            title,
            message
        });
        setShow(true);
        return new Promise(function (resolve) {
            resolver.current = resolve;
        });
    };

    const modalContext: ModalContextType = {
        show : onShow
    };

    const onClick_Ok = () => {
        resolver.current && resolver.current(true);
        onHide();
    };

    return (
        <AlertMessageContext.Provider value={modalContext}>
            {props.children}

            {content &&
                <Modal 
                    show={show} 
                    onHide={onHide} 
                    dialogClassName={`modal-md`}
                    backdrop="static"
                    className="message-context"
                >
                    <Modal.Header>
                        <Modal.Title className='d-flex'><Image className='me-3' src={logoNauti} style={{width: "23px", marginTop: "-5px"}} /> {content.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <label>{treatError(content.message)}</label>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="contained" color="primary" onClick={onClick_Ok}>{display.buttom.okay}</Button>
                    </Modal.Footer>
                </Modal>}
        </AlertMessageContext.Provider>
    )
};

const useAlertMessageContext = (): ModalContextType => useContext(AlertMessageContext);

export {
    useModalShow,
    useAlertMessageContext,
}

export default AlertMessageContextProvider;